import PropTypes from "prop-types";
import { Box, Button, ListItem } from "@mui/material";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
export const NavItem = (props) => {
    const { to, icon, title, onClick, ...others } = props;
    const location = useLocation();
    const [targetPath = "", targetQuery = ""] = to ? to.split("?") : [];
    const normalizePath = (path) => String(path || "").replace(/\/$/, "") || "/";
    const isGroupMatch = (hrefPath, currentPath) => {
        if (!hrefPath || !currentPath) return false;
        const normTarget = normalizePath(hrefPath).toLowerCase();
        const normCurrent = normalizePath(currentPath).toLowerCase();

        if (normTarget === normCurrent) return true;

        if (normTarget.includes("setxd") || normTarget.includes("set-xd")) {
            return normCurrent.includes("setxd") || normCurrent.includes("set-xd");
        }
        if (normTarget.includes("settx") || normTarget.includes("set-tx")) {
            return normCurrent.includes("settx") || normCurrent.includes("set-tx");
        }
        if (normTarget.includes("setbaccarat")) {
            return normCurrent.includes("setbaccarat");
        }
        if (normTarget.includes("setbaucua")) {
            return normCurrent.includes("setbaucua");
        }
        if (normTarget.includes("setrongho")) {
            return normCurrent.includes("setrongho");
        }
        if (normTarget.includes("setxs")) {
            return normCurrent.includes("setxs");
        }
        return false;
    };

    const active = Boolean(
        targetPath && (
            isGroupMatch(targetPath, location.pathname) ||
            (targetQuery 
                ? (normalizePath(location.pathname) === normalizePath(targetPath) && location.search === `?${targetQuery}`)
                : (normalizePath(location.pathname) === normalizePath(targetPath) && !location.search)
            )
        )
    );

    useEffect(() => {
        if (active) {
            document.title = title;
        }
    }, [active, title]);

    return (
        <>
            <ListItem
                disableGutters
                className={active ? "happy-nav-item is-active" : "happy-nav-item"}
                sx={{
                    display: "flex",
                    width: "calc(100% - 8px)",
                    height: "45px",
                    m: 0.5,
                    py: 0,
                    px: 0
                }}>
                <Link to={to} style={{ width: "100%", textDecoration: "none" }} onClick={onClick}>
                    <Button
                        component="a"
                        startIcon={icon}
                        disableRipple
                        sx={{
                            background: active ? "#f45b1a" : "transparent",
                            borderRadius: "8px",
                            color: "#FFFFFF !important",
                            fontWeight: active ? 700 : 500,
                            letterSpacing: 0,
                            fontSize: "15px",
                            justifyContent: "flex-start",
                            px: 3,
                            py: 0,
                            height: "45px",
                            textAlign: "left",
                            textTransform: "none",
                            width: "100%",
                            boxShadow: "none",
                            "& .MuiButton-startIcon": {
                                color: "#FFFFFF !important",
                                width: "24px",
                                marginRight: "20px",
                                fontSize: "20px"
                            },
                            "&:hover": {
                                background: active ? "#f45b1a" : "rgba(255, 255, 255, 0.14)"
                            }
                        }}>
                        <Box sx={{ flexGrow: 1, color: "#FFFFFF !important", fontWeight: active ? 700 : 500 }}>{title}</Box>
                    </Button>
                </Link>
            </ListItem>
        </>
    );
};

NavItem.propTypes = {
    href: PropTypes.string,
    icon: PropTypes.node,
    title: PropTypes.string
};
